import { render, staticRenderFns } from "./KoreksiList.vue?vue&type=template&id=7a7e3cdc&"
import script from "./KoreksiList.vue?vue&type=script&lang=js&"
export * from "./KoreksiList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/jqwidgets/jqx.base.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports